module.exports = __webpack_public_path__ + "img/all-done.255e7217.svg";